"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NumberControl = exports.getNumberIcon = exports.CONTROL_TYPE = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _IconButton = require("./buttons/IconButton");

var _iconConst = require("./icons/iconConst");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CONTROL_TYPE = {
  DECREMENT: 'decrement',
  INCREMENT: 'increment'
}; // Factored out to reduce complexity for eslint

exports.CONTROL_TYPE = CONTROL_TYPE;

var getNumberIcon = function getNumberIcon(usePlusMinus, light, isIncrement) {
  var icon = isIncrement ? _iconConst.CARET_RIGHT : _iconConst.CARET_LEFT;

  if (usePlusMinus) {
    icon = isIncrement ? _iconConst.PLUS : _iconConst.MINUS;

    if (light) {
      icon = isIncrement ? _iconConst.PLUS_LIGHT : _iconConst.MINUS_LIGHT;
    }
  }

  return icon;
};

exports.getNumberIcon = getNumberIcon;

var NumberControl = function NumberControl(_ref) {
  var inputId = _ref.inputId,
      cashbotName = _ref.cashbotName,
      onClick = _ref.onClick,
      type = _ref.type,
      incLabel = _ref.incLabel,
      decLabel = _ref.decLabel,
      usePlusMinus = _ref.usePlusMinus,
      light = _ref.light;
  var isIncrement = type === CONTROL_TYPE.INCREMENT;
  var icon = getNumberIcon(usePlusMinus, light, isIncrement);
  var controlProps = {
    atts: {
      'aria-controls': inputId,
      tabIndex: 0
    },
    cssClass: 'spinner-control',
    ariaLabel: isIncrement ? incLabel : decLabel,
    icon: icon,
    onClick: onClick,
    cashbotName: "".concat(cashbotName, "-").concat(type)
  };
  return _react.default.createElement(_IconButton.IconButton, controlProps);
};

exports.NumberControl = NumberControl;
NumberControl.defaultProps = {
  usePlusMinus: false,
  light: false
};
NumberControl.propTypes = {
  inputId: _propTypes.default.string.isRequired,
  cashbotName: _propTypes.default.string.isRequired,
  onClick: _propTypes.default.func.isRequired,
  type: _propTypes.default.oneOf([CONTROL_TYPE.INCREMENT, CONTROL_TYPE.DECREMENT]).isRequired,
  incLabel: _propTypes.default.string.isRequired,
  decLabel: _propTypes.default.string.isRequired,
  usePlusMinus: _propTypes.default.bool,
  light: _propTypes.default.bool
};